/**
* @render react
* @name Icon
*/

import React from 'react';
import PropTypes from 'prop-types';

import { withPolaris } from 'Components/protons/Polaris';

/**
 * Icon component
 *
 * All icons are within the sprite which is generated by the SVGSpritemapPlugin plugin. It looks for any SVGs found in the images/svg-sprite folder
 * and then generates the sprite as per its configuration in webpack.
 *
 * @param {Object} props - the props object
 * @param {string} props.sprite - The SVG sprite
 * @param {string} props.icon - The icon we want to display
 * @param {Object} props.context - Extra information coming from Polaris provider.
 */
const Icon = (
  {
    icon,
    context: { svgSpritePath },
  },
) => (
  <svg>
    <use xlinkHref={`${svgSpritePath}#${icon}`} />
  </svg>
);

/**
 * Valid props
 */
Icon.propTypes = {
  icon: PropTypes.string,
  context: PropTypes.shape(),
};

/**
 * Default props
 */
Icon.defaultProps = {
  icon: '',
  context: {},
};

export default withPolaris(Icon);
